import React from "react";
import {
  IoIosBrush as CreatedIcon,
  IoIosRocket as InTransitIcon,
  IoIosThumbsDown as DeclinedIcon,
  IoIosThunderstorm as ServiceIcon,
  IoIosTimer as ReviewIcon,
  IoMdCloud as CompleteIcon,
} from "react-icons/io";

let refertenceLibrary = {
  statusSelectors: [
    {
      id: 1,
      name: "Awaiting Confirmation / Pending Approval",
      icon: <CreatedIcon className={"warranties-summary-individual-icon"} />,
      color: "#2475B0",
    },
    {
      id: 2,
      name: "Pending Return Label to be Sent",
      icon: <InTransitIcon className={"warranties-summary-individual-icon"} />,
      color: "#00695C",
    },
    {
      id: 3,
      name: "Pending Customer to Download Return Label",
      icon: <InTransitIcon className={"warranties-summary-individual-icon"} />,
      color: "#1A237E",
    },
    {
      id: 4,
      name: "Pending Receipt of Goods",
      icon: <InTransitIcon className={"warranties-summary-individual-icon"} />,
      color: "#1A237E",
    },

    {
      id: 5,
      name: "Goods received pending replacement to be sent",
      icon: <ReviewIcon className={"warranties-summary-individual-icon"} />,
      color: "#B71C1C",
    },
    {
      id: 6,
      name: "Replacement Sent",
      icon: <ServiceIcon className={"warranties-summary-individual-icon"} />,
      color: "#E65100",
    },
    {
      id: 7,
      name: "Not Approved",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 8,
      name: "Awaiting Parts",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },

    {
      id: 9,
      name: "Service Completed",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 10,
      name: "Goods Assessed and require additional payment (if applicable)",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 11,
      name: "Goods received and under repair",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 12,
      name: "Declined",
      icon: <DeclinedIcon className={"warranties-summary-individual-icon"} />,
      color: "#D50000",
    },
    {
      id: 13,
      name: "Repair complete, goods sent out",
      icon: <InTransitIcon className={"warranties-summary-individual-icon"} />,
      color: "#1A237E",
    },
    {
      id: 14,
      name: "Approved Pending payment of service charge",
      icon: <ReviewIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 15,
      name: "Approved - Pending acceptance of Assessment Fee",
      icon: <ReviewIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 16,
      name: "Refund Processed (Completed)",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 17,
      name: "Goods Received pending Refund",
      icon: <InTransitIcon className={"warranties-summary-individual-icon"} />,
      color: "#1A237E",
    },

    {
      id: 18,
      name: "Spare Parts Approved, Pending Dispatch",
      icon: <ReviewIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 19,
      name: "Spare Parts Dispatched, Issue Resolved",
      icon: <CompleteIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 20,
      name: "Did Not Proceed",
      icon: <DeclinedIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
    {
      id: 21,
      name: "Completed",
      icon: <DeclinedIcon className={"warranties-summary-individual-icon"} />,
      color: "#212121",
    },
  ],
  statusClosed: [
    "Did Not Proceed",
    "Not Approved",
    "Service Completed",
    "Completed",
    "Refund Processed",
    "Replacement Sent",
    "Repair complete, goods sent out",
    "Spare Parts Dispatched, Issue Resolved",
    "Credit Claim Resolved / Completed",
  ],

  statusArchived: ["Not Approved", "Service Completed", "Did not Proceed", "Completed"],
  statusTracking: ["Repair complete, goods sent out", "Replacement Sent", "Spare Parts Dispatched, Issue Resolved"],
  warrantyTypes: [
    { value: "service", label: "Repair" },
    { value: "refund", label: "Refund" },
    { value: "replacement", label: "Replace / Upgrade" },
    { value: "credit_claim", label: "Commercial - Credit Claim" },
    { value: "spare_parts_only", label: "Spare Parts Only" },
  ],
  ooWarrantyTypes: [
    { value: "service", label: "Repair" },
    { value: "credit_claim", label: "Commercial - Credit Claim" },
  ],
  repairStatuses: ["Pending Repair", "Awaiting Parts", "Goods received and under repair"],
  pendingRepairStatuses: ["Awaiting Parts", "Goods received and under repair"],
  awaitingPartStatuses: ["Pending Repair", "Goods received and under repair"],
  underRepairStatuses: ["Pending Repair", "Awaiting Parts", "Repair complete, goods sent out"],
};

export default refertenceLibrary;
